export enum DeviceStateType {
  active = "active",
  inactive = "inactive",
  blocked = "blocked",
};

export namespace DeviceStateType {
  export const translateOrigin = (type: DeviceStateType): string => {
    switch (type) {
      case DeviceStateType.active:
        return "Ativo";
      case DeviceStateType.inactive:
        return "Inativo";
      case DeviceStateType.blocked:
        return "Bloqueado";
      default: return "";
    };
  };

  export const DeviceStateTypeChoices = Object.values(DeviceStateType).filter(x => typeof x === "string")
    .map(type => {
      return ({
        id: type,
        name: DeviceStateType.translateOrigin(type)
      });
    });
};